import {isEmpty} from "lodash"
import * as localStorage from "./localStorage"
import * as sessionStorage from "./sessionStorage"
import {checkIfEmptyStorageNeeded, getLastVersion} from "./version"

export const checkVersion = (VersionKeys, Versions, key) => {
    const actualVersion = localStorage.loadVersion(key)
    const session = sessionStorage.loadState()
    const lastVersion = getLastVersion(Versions)

    if (checkIfEmptyStorageNeeded(actualVersion, Versions, VersionKeys)) {
        const cesu = session?.user?.details?.cesu
        const sap = session?.user?.details?.sap

        // Si les deux n'existent pas OU si les deux sont vides OU si un seul est rempli
        if (!cesu || !sap || isEmpty(cesu) || isEmpty(sap)) {
            localStorage.clearStorage()
        }

        if (process.env.NODE_ENV !== "production") {
            console.info("Clear storage : from version " + actualVersion + " to " + lastVersion)
        }
    }

    localStorage.saveVersion(lastVersion, key)
}
